// 使用环境变量，默认为空（生产环境使用相对路径）
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const API = {
  BASE_URL: API_BASE_URL,
  
  CHAT: {
    SEND: `${API_BASE_URL}/api/chat/send`,
    MESSAGES: (userId) => `${API_BASE_URL}/api/chat/messages/${userId}`,
    REPLY: `${API_BASE_URL}/api/chat/reply`
  },
  
  WECHAT: {
    NOTIFY: `${API_BASE_URL}/api/wechat/notify`,
    REPLY: `${API_BASE_URL}/api/wechat/reply`,
    DEPARTMENTS: `${API_BASE_URL}/api/wechat/departments`,
    USERS: `${API_BASE_URL}/api/wechat/users`,
    CALLBACK: `${API_BASE_URL}/api/wechat/callback`
  },
  
  DEEPSEEK: {
    CHAT: `${API_BASE_URL}/api/deepseek/chat`
  },
  
  KNOWLEDGE: {
    LEARN: `${API_BASE_URL}/api/knowledge/learn`,
    SEARCH: `${API_BASE_URL}/api/knowledge/search`,
    LIST: `${API_BASE_URL}/api/knowledge`,
    RELEARN: `${API_BASE_URL}/api/knowledge/relearn`,
    UPDATE: `${API_BASE_URL}/api/knowledge/update`,
    AUTO_LEARN: `${API_BASE_URL}/api/knowledge/auto-learn`,
    GRAPH: `${API_BASE_URL}/api/knowledge/graph`,
    ANALYSIS: `${API_BASE_URL}/api/knowledge/analysis`,
    DELETE: (id) => `${API_BASE_URL}/api/knowledge/${id}`,
    UPDATE_ITEM: (id) => `${API_BASE_URL}/api/knowledge/${id}`
  },
  
  WS_URL: (userId) => {
    if (API_BASE_URL && API_BASE_URL.trim()) {
      const wsProtocol = API_BASE_URL.startsWith('https') ? 'wss' : 'ws';
      const wsHost = API_BASE_URL.replace(/^https?:\/\//, '');
      return `${wsProtocol}://${wsHost}/?userId=${userId}`;
    } else {
      // 当API_BASE_URL为空时，使用默认的localhost:5000
      return `ws://localhost:5000/?userId=${userId}`;
    }
  },
  
  ADMIN: {
    LOGIN: `${API_BASE_URL}/api/admin/login`,
    USERS: `${API_BASE_URL}/api/admin/users`,
    SERVICE_RECORDS: `${API_BASE_URL}/api/admin/service-records`,
    SERVICE_RECORDS_STATS: `${API_BASE_URL}/api/admin/service-records/stats`,
    QUICK_REPLIES: `${API_BASE_URL}/api/admin/quick-replies`
  },

  PUBLIC: {
    QUICK_REPLIES: `${API_BASE_URL}/api/quick-replies`,
    CHAT_SETTINGS: `${API_BASE_URL}/api/chat-settings`
  }
};

export default API;
